
<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import FormStatusMixin from "../../../author/pagesbuilder/mixins/FormStatusMixin";


    export default {
        name: "LeadWrapperElement",
        mixins: [
            AnimationsMixin,
            FormStatusMixin
        ],
        data () {
            return {
                elementType: 'lead-form-wrapper',
            }
        }
    }
</script>

